module.exports = __webpack_public_path__ + "img/xmasParty14.a10f3f47.jpg";